import script from "./ReportingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportingPage.vue?vue&type=script&setup=true&lang=js"

import "./ReportingPage.vue?vue&type=style&index=0&id=b2f2dcae&lang=scss&scoped=true"
import "./ReportingPage.vue?vue&type=style&index=1&id=b2f2dcae&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2f2dcae"]])

export default __exports__